module.exports = __webpack_public_path__ + "static/media/20ECE15.897695fb.jpg";